/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Splátková platba bez poplatků`
};

const da_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Betal i flere rater uden gebyr`
};

const de_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Ratenzahlung ohne Gebühren`
};

const en_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Payment in several instalments, free of charge`
};

const es_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pago en varias cuotas sin intereses`
};

const fr_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Paiement en plusieurs fois sans frais`
};

const hu_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Részletfizetés díjmentesen`
};

const it_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pagamento in più rate senza costi`
};

const nl_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Betalen in meerdere termijnen zonder kosten`
};

const pl_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Płatność na raty bez dodatkowych opłat`
};

const pt_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pagamento parcelado sem juros`
};

const sv_reinsurances_multiple_time_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Delbetalning utan avgift`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_multiple_time_payment = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_multiple_time_payment(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_multiple_time_payment", locale)
	if (locale === "cs") return cs_reinsurances_multiple_time_payment(inputs)
	if (locale === "da") return da_reinsurances_multiple_time_payment(inputs)
	if (locale === "de") return de_reinsurances_multiple_time_payment(inputs)
	if (locale === "en") return en_reinsurances_multiple_time_payment(inputs)
	if (locale === "es") return es_reinsurances_multiple_time_payment(inputs)
	if (locale === "fr") return fr_reinsurances_multiple_time_payment(inputs)
	if (locale === "hu") return hu_reinsurances_multiple_time_payment(inputs)
	if (locale === "it") return it_reinsurances_multiple_time_payment(inputs)
	if (locale === "nl") return nl_reinsurances_multiple_time_payment(inputs)
	if (locale === "pl") return pl_reinsurances_multiple_time_payment(inputs)
	if (locale === "pt") return pt_reinsurances_multiple_time_payment(inputs)
	return sv_reinsurances_multiple_time_payment(inputs)
};
export { reinsurances_multiple_time_payment as "reinsurances.multiple_time_payment" }